import React from 'react';
import { expandFontTheme, IconHelp, theme } from '@contrast-security-inc/design-system-foundations';
import { Tooltip } from '@contrast-security-inc/design-system-popovers';
import { Link, Text } from '@contrast-security-inc/design-system-typography';
import { css } from '@emotion/css';
const helpStyles = css `
  display: flex;
  align-items: center;
  min-height: 21px;
  ${expandFontTheme(theme.font.metadata)};
  color: ${theme.color.neutral100};
  padding-bottom: 3px;

  div {
    display: flex;
    align-items: center;
  }

  svg {
    padding-left: 4px;
  }
`;
const HelpToolTip = ({ TooltipProps, testId, children }) => {
    if (TooltipProps) {
        return (React.createElement(Tooltip, { body: TooltipProps.body, testId: testId && `${testId}-help-tooltip` },
            React.createElement("div", null, children)));
    }
    return React.createElement(React.Fragment, null, children);
};
const HelpLabel = ({ href, isExternal, label, testId }) => {
    if (href) {
        return (React.createElement(Link, { href: href, isExternal: isExternal, testId: testId && `${testId}-help-link` }, label));
    }
    else if (label !== undefined) {
        return (React.createElement(Text, { font: "metadata", color: "neutral100", testId: testId && `${testId}-help-label` }, label));
    }
    return null;
};
export const Help = ({ label, testId, id, TooltipProps, href, isExternal }) => {
    if (!label && !TooltipProps?.body) {
        return null;
    }
    return (React.createElement("span", { id: id && `${id}-help`, className: helpStyles, "data-testid": testId && `${testId}-help` },
        React.createElement(HelpLabel, { label: label, href: href, isExternal: isExternal, testId: testId }),
        React.createElement(HelpToolTip, { testId: testId, TooltipProps: TooltipProps },
            React.createElement(IconHelp, { size: "sm", color: "neutral60", testId: testId && `${testId}-help-icon` }))));
};
